<!-- frontend/src/components/LogoutPage.vue -->
<template>
  <div>Logging out...</div>
</template>

<script>
import {useAuthStore} from '@/store/auth.js'
import {useRouter} from 'vue-router'

export default {
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()

    authStore.logout().then(() => {
      router.push('/login')
    }).catch(error => {
      console.error('Logout failed:', error)
    })
  }
}
</script>